
import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
} from "@shared/ui/dialog";
import { FileText } from "lucide-react";
import { PaymentInformationCard } from "./cardComponents/paymentInformationCard";
import { CustomerInformationCard } from "./cardComponents/customerInformationCard";
import { PaymentDetail } from '@features/cx/payments/types';
import { usePaymentDetail } from "@features/cx/payments/hooks";
interface PaymentDetailDialogProps {
  payment: PaymentDetail | null;
  open: boolean;
  onClose: () => void;
  onViewCreditNote?: (creditNoteNumber: string) => void;
}

export function PaymentDetailDialog({ payment, open, onClose, onViewCreditNote }: PaymentDetailDialogProps) {
  if (!payment) return null;
  const { data: paymentDetail } = usePaymentDetail({
    paymentId: payment.id,
    remoteUtilityId: payment.remoteUtilityId,
  });

  return (
    <Dialog open={open} onOpenChange={onClose}>
      <DialogContent className="max-w-4xl max-h-[90vh] overflow-y-auto">
        <DialogHeader>
          <DialogTitle className="flex items-center gap-2">
            <FileText className="h-5 w-5" />
            Payment Details - {payment.receiptNo || 'N/A'}
          </DialogTitle>
        </DialogHeader>

        <div className="space-y-6">
          {/* Payment Summary and Transaction Details */}
          <PaymentInformationCard 
            payment={paymentDetail?.result} 
            onViewCreditNote={onViewCreditNote}
          />

          {/* Customer Information */}
          <CustomerInformationCard payment={paymentDetail?.result} />
        </div>
      </DialogContent>
    </Dialog>
  );
}
